// ===================================================================
// KAIXO - friendlyError
// ===================================================================
// Convierte errores técnicos (Axios, fetch, throw) en mensajes
// legibles que se pueden mostrar al usuario sin exponer stacks ni
// detalles internos. Antes había una copia local en ChatWindow; ahora
// vive aquí para que todos los modales/páginas lo usen.
//
// Devuelve siempre un string corto y útil (máx 120 chars).
// ===================================================================

export function friendlyError(err, fallback = 'Algo salió mal') {
    if (!err) return fallback;

    // 1. Mensaje del servidor (si lo trae y es razonable)
    const server = err.response?.data?.error || err.response?.data?.message;
    if (server && typeof server === 'string' && server.length < 200) {
        return server;
    }

    const m = err.message || '';
    const status = err.response?.status;

    // 2. Mapeo por código HTTP — más fiable que parsear el message
    if (status === 401) return 'Tu sesión ha caducado. Inicia sesión de nuevo.';
    if (status === 403) return 'No tienes permiso para esta acción.';
    if (status === 404) return 'No encontrado.';
    if (status === 409) return 'Conflicto — recarga e intenta de nuevo.';
    if (status === 413) return 'El archivo es demasiado grande.';
    if (status === 429) return 'Demasiadas peticiones. Espera un momento.';
    if (status >= 500 && status < 600) return 'Servicio no disponible. Reintenta en un momento.';

    // 3. Mapeo por mensaje (red caída, timeouts)
    if (/network/i.test(m)) return 'Sin conexión. Comprueba tu Internet.';
    if (/timeout/i.test(m)) return 'La conexión tardó demasiado. Reintenta.';
    if (/aborted/i.test(m)) return 'Operación cancelada.';

    // 4. Si es un mensaje corto y plano, lo mostramos. Si es técnico/largo,
    // fallback genérico para no exponer stacks.
    if (!m || m.length > 120) return fallback;
    if (/^[A-Za-z]+Error:/.test(m)) return fallback;  // TypeError:, SyntaxError:, etc.
    return m;
}

export default friendlyError;
